module.exports = __webpack_public_path__ + "static/img/A2E_training_South-Africa2017.55bc0e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_training_South-Africa2017.jpg
// module id = UInJ
// module chunks = 0